export default {
  name: {
    id: 'rm_metal_vanadium_name',
    defaultMessage: 'Vanadium',
  },
  smartphoneLabel: {
    id: 'rm_metal_vanadium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_vanadium_what_it_does',
    defaultMessage:
      "Vanadium is a vital ingredient added to the titanium used in premium smartphones to make it incredibly strong yet lightweight. Without it, pure titanium would bend too easily to protect a phone's delicate internal parts.",
  },
  extractionText1: {
    id: 'rm_metal_vanadium_extraction_p1',
    defaultMessage:
      'Vanadium is mined from vanadium-bearing magnetite and other ores, but around 70% is produced as a co-product of iron and steelmaking. The ore is concentrated, reduced to hot metal and oxidised to produce vanadium slag. The slag is roasted with sodium salts, leached and processed into vanadium oxides, which can be converted into ferrovanadium. Secondary sources include fly ash, petroleum residues and spent catalysts.',
  },
  quickFactText: {
    id: 'rm_metal_vanadium_quick_fact',
    defaultMessage:
      'China produces around two-thirds of the world’s vanadium, making this steel-strengthening metal strategically important.',
  },
  envSummaryText: {
    id: 'rm_metal_vanadium_env_summary',
    defaultMessage:
      'Vanadium mining, steel co-production and processing generate dust, slags, fly ash and other residues. Industrial emissions can contaminate air, soil and water, while oil refineries and power plants that use vanadium-rich fuels are major sources of vanadium emissions.',
  },
  envWaterText: {
    id: 'rm_metal_vanadium_env_water_text',
    defaultMessage:
      'Mining and processing can consume water and generate wastewater, slags and other residues. Airborne vanadium particles can settle in soil, sediments and bodies of water. The sources provide no vanadium-specific estimate of water scarcity.',
  },
  envSoilText: {
    id: 'rm_metal_vanadium_env_soil_text',
    defaultMessage:
      'Mining can remove vegetation and topsoil, while vanadium-bearing dust, slags and residues may contaminate soils. Vanadium particles can settle in soil and sediments, particularly near industrial facilities and fossil-fuel combustion sites.',
  },
  envBiodiversityText: {
    id: 'rm_metal_vanadium_env_biodiversity_text',
    defaultMessage:
      'Vanadium is toxic to humans and animals, and emissions or residues can affect ecosystems.',
  },
  envClimateText: {
    id: 'rm_metal_vanadium_env_climate_text',
    defaultMessage:
      'Vanadium climate footprint is linked mainly to iron and steel production, high-temperature slag processing and the refining or combustion of vanadium-rich fuels.',
  },
  humanSummaryText: {
    id: 'rm_metal_vanadium_human_summary',
    defaultMessage:
      'Workers can be exposed to airborne vanadium dust, particularly vanadium pentoxide, during vanadium-related industrial activities such as steelmaking and chemical processing. Inhalation can cause eye irritation, bronchitis, bronchospasm and asthma-related symptoms.',
  },
  humanHealthText: {
    id: 'rm_metal_vanadium_human_health_text',
    defaultMessage:
      'Vanadium is toxic to humans and animals. Occupational exposure to vanadium pentoxide dust can cause eye irritation, bronchitis, bronchospasm and asthma-related symptoms. Acute or chronic exposure can also damage the kidneys, although the long-term effects of exposure have not been widely studied.',
  },
  geoSummaryText: {
    id: 'rm_metal_vanadium_geo_summary',
    defaultMessage:
      'The vanadium supply chain is concentrated at both the mining and processing stages: China accounted for approximately 67% of listed 2024 mine production and approximately 65% of average global processing-stage production, giving it significant influence over global supply. Vanadium is used in defence applications, including submarine hulls, armour and aerospace structures, and is classified as a strategic raw material under the EU Critical Raw Materials Act (2024).',
  },
  geoDugText: {
    id: 'rm_metal_vanadium_geo_dug_text',
    defaultMessage:
      'Vanadium mine production is highly concentrated. China accounted for approximately 67% of the listed 2024 production, followed by Russia at 20%, South Africa at 8% and Brazil at 5%.',
  },
  geoProcessedText: {
    id: 'rm_metal_vanadium_geo_processed_text',
    defaultMessage:
      'Between 2020 and 2024, China accounted for approximately 65% of global processing-stage production, followed by Russia, Europe and South Africa at around 7% each, Brazil at 5%, North America at 3% and Japan at 2%. The European Union was approximately 84% dependent on imports for processed vanadium.',
  },
  geoLeverageText: {
    id: 'rm_metal_vanadium_geo_leverage_text',
    defaultMessage:
      'China introduced export-licensing requirements for vanadium ores and concentrates in 2022. The IEA ranks vanadium as the second-most price-unstable material among the 20 materials it tracks.',
  },
  supplySummaryText: {
    id: 'rm_metal_vanadium_supply_summary',
    defaultMessage:
      'Supply may struggle to keep pace with rapid demand growth because most vanadium is produced as a by-product or co-product of iron and steelmaking. Mines and steel plants cannot always increase vanadium output quickly in response to higher demand. The development of vanadium flow batteries could add further pressure to supply chains.',
  },
  supplyReservesText: {
    id: 'rm_metal_vanadium_supply_reserves_text',
    defaultMessage:
      'Global vanadium reserves total approximately 18 million tonnes. Australia holds the largest share, with around 8.5 million tonnes, followed by Russia with 5 million tonnes and China with 4.1 million tonnes. Together, these three countries account for approximately 97% of the listed reserves.',
  },
  supplyDemandText: {
    id: 'rm_metal_vanadium_supply_demand_text',
    defaultMessage:
      'Steel applications accounted for more than 90% of global vanadium demand in 2022. Demand is driven mainly by high-strength and specialty steels used in construction, automotive and aerospace applications. Vanadium redox flow batteries are projected to become an important additional source of demand for grid-scale energy storage: vanadium demand from grid-scale battery storage is projected to increase more than twentyfold, from 27 kt in 2030 to 553 kt in 2050.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_vanadium_recycling_summary',
    defaultMessage:
      'Vanadium recycling is generally very low. Recovered material comes mainly from steel scrap, spent chemical catalysts and industrial residues such as fly ash, petroleum residues and slags. The end-of-life recycling input rate in the European Union was approximately 1% in 2022.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_vanadium_recycling_outlook_text',
    defaultMessage: 'Not on its own.',
  },
  footnote1Text1: {
    id: 'rm_metal_vanadium_footnote_1_p1',
    defaultMessage:
      'As Vanadium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  mine0Region: {
    id: 'rm_metal_vanadium_mine0_region',
    defaultMessage: 'Panzhihua',
  },
  mine1Region: {
    id: 'rm_metal_vanadium_mine1_region',
    defaultMessage: 'Mokopane',
  },
  mine2Region: {
    id: 'rm_metal_vanadium_mine2_region',
    defaultMessage: 'Kachkanar',
  },
  mine3Region: {
    id: 'rm_metal_vanadium_mine3_region',
    defaultMessage: 'Steelpoort',
  },
  mine4Region: {
    id: 'rm_metal_vanadium_mine4_region',
    defaultMessage: 'Maracás',
  },
} as const
